import React from 'react'
import { Header } from '../Components/Header'
import { Footer } from '../Components/Footer'
import { Service } from '../Components/Service'
import {Helmet} from 'react-helmet'

export const Services = () => {
    return (
        <React.Fragment>
            <Helmet>
                <title>Hizmetler - Kuzey Software</title>
            </Helmet>
            <Header />
            <Service />
            <Footer />
        </React.Fragment>
    )
}
